<template>
  <div>
    <div class="px-4 pt-4">
      <h4 class="mb-0">
        {{ $t("tabs.settings.title") }}
      </h4>
    </div>

    <profile-info />

    <div class="p-4 user-profile-desc">
      <b-card
        no-body
        class="custom-accordion border"
      >
        <b-card-header>
          <h5 class="font-size-14 m-0">
            {{ $t('tabs.settings.title') }}
          </h5>
        </b-card-header>
        <b-card-body>
          <tab-setting-language />
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import ProfileInfo from './Profile/InfoProfileTabComponents';
import TabSettingLanguage from "./Setting/LanguageSettingTabComponents";

export default {
  components: {
    ProfileInfo,
    TabSettingLanguage,
  },
};
</script>
